import React, { useState } from "react";
import { useNavigate } from "react-router";
import Header from "src/components/Header";
import Footer from "src/components/Footer";
import AboutButton from "src/components/AboutButton";
import WaitlistPopup from "src/components/WaitlistPopup";

function About() {
  const navigate = useNavigate();
  const [showPopup, setShowPopup] = useState(false);

  return (
    <div className="relative z-10 h-full w-full flex flex-col items-center justify-start mx-[16px]">
      <div className="w-full items-center justify-center flex px-2 md:px-[15%]">
        <Header isUserLoggedIn={true} onPress={() => navigate("/")} />
      </div>

      <main
        style={{ maxWidth: 640, margin: "2rem auto" }}
        className="bg-white rounded-3xl p-8 text-black shadow-md h-full overflow-y-scroll"
      >
        <header className="mb-10">
          <h1 className="text-3xl font-semibold mb-4">Our Story</h1>
          <p className="italic text-base leading-relaxed mb-6">
            “After frantically searching for the cheapest tickets, comparing endless tabs, and triple-checking accommodation preferences...we realised something was missing. We needed a tool, a companion, a space where we could finally breathe. A place where the stress ends and the dreaming begins.”
          </p>
          <p className="text-base leading-relaxed">
            Years ago, we sat cross-legged on bedroom floors and café tables, building trips out of hopes and browser bookmarks. We lived for the thrill of imagining what it would feel like to walk the streets of Kyoto at dawn, to sip espresso in a sleepy Italian town, or to get lost in a night market&apos;s swirl of scent and sound.
          </p>
          <br />
          <p className="text-base leading-relaxed">
            But something always pulled us out of the moment:{" "}
            <span className="font-semibold italic">piecing everything together.</span>.
            <br />
            We didn&apos;t want travel to feel like a job.
            <br />
            We wanted it to feel like possibility.
            <br />
            <br />
            So we set out to build a space for just that.
          </p>
        </header>

        <div className="my-8 flex justify-center">
          <svg
            width="120"
            height="20"
            viewBox="0 0 120 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="text-gray-400"
          >
            <path
              d="M2 10 Q10 2, 20 10 T40 10 T60 10 T80 10 T100 10 T118 10"
              stroke="currentColor"
              strokeWidth="2"
              fill="transparent"
              strokeLinecap="round"
            />
          </svg>
        </div>


        {/* New Section Heading */}
        <h2 className="text-2xl font-semibold mb-6">What drives us</h2>

        <section className="mb-8">
          <h2 className="text-l font-medium mb-3">Curiosity</h2>
          <p className="text-base leading-relaxed">
            The spark that lights our journey.
          </p>
          <p className="mt-2 text-base leading-relaxed">
            For us, it&apos;s more than just travel. It&apos;s an immersion into the stories we share, the plans we make, and the experiences we live.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-l font-medium mb-3">Exploration</h2>
          <p className="text-base leading-relaxed">
            Experiencing the world beyond our everyday.
          </p>
          <p className="mt-2 text-base leading-relaxed">
            These are moments when we turn our sparetime into something meaningful. Completely immersed in the world around us.
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-l font-medium mb-3">Connection</h2>
          <p className="text-base leading-relaxed">
            The heartbeat of every journey.
          </p>
          <p className="mt-2 text-base leading-relaxed">
            These moments stay with us, reminding us that it&apos;s the bonds we create with people, places, and self that truly shape our journey.
          </p>
        </section>

        <div className="my-8 flex justify-center">
          <svg
            width="120"
            height="20"
            viewBox="0 0 120 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="text-gray-400"
          >
            <path
              d="M2 10 Q10 18, 20 10 T40 10 T60 10 T80 10 T100 10 T118 10"
              stroke="currentColor"
              strokeWidth="2"
              fill="transparent"
              strokeLinecap="round"
            />
          </svg>
        </div>
          <p className="mt-2 text-base leading-relaxed">
            Whether you&apos;re planning your first solo adventure, a family reunion, or a quiet escape, Sparetime keeps your trips and travel plans all in one place.
          </p>
        <AboutButton onClick={() => setShowPopup(true)} />
      </main>

      <Footer />

      {showPopup && <WaitlistPopup onClose={() => setShowPopup(false)} />}
    </div>
  );
}

export default About;
